var baseStyleOverlay = {
  bg: 'blackAlpha.400',
  zIndex: 'modal'
};
var baseStyleHeader = {
  px: 8,
  py: 6,
  fontSize: '2xl',
  fontWeight: 'semibold',
  borderBottom: '1px solid',
  borderColor: 'gray.300'
};
var baseStyleCloseButton = {
  position: 'absolute',
  top: 6,
  right: 8,
  color: 'brand.500'
};

function baseStyleBody(props) {
  var {
    scrollBehavior
  } = props;
  return {
    px: 8,
    py: 6,
    flex: 1,
    overflow: scrollBehavior === 'inside' ? 'auto' : undefined
  };
}

var baseStyleFooter = {
  px: 8,
  pt: 10,
  pb: 8
};

var baseStyle = props => ({
  overlay: baseStyleOverlay,
  header: baseStyleHeader,
  closeButton: baseStyleCloseButton,
  body: baseStyleBody(props),
  footer: baseStyleFooter
});

var defaultProps = {
  size: 'md',
  colorScheme: 'brand'
};
export default {
  baseStyle,
  defaultProps
};
//# sourceMappingURL=Modal.js.map